import styled from "styled-components";

import { Box } from "src/components";

export const Container = styled(Box)`
  width: 100%;
  max-width: 370px;
  margin: 200px auto 100px;
`;
